import { useState, useEffect } from 'react';
import { useAuthenticatedApi } from './useAuthenticatedApi';

const useTerminalState = (workspaceId) => {
  const [terminalState, setTerminalState] = useState({ terminals: [] });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const api = useAuthenticatedApi();

  useEffect(() => {
    console.log('[useTerminalState] workspaceId:', workspaceId);
    
    if (!workspaceId) {
      console.log('[useTerminalState] No workspaceId, skipping fetch');
      setTerminalState({ terminals: [] });
      return;
    }

    const fetchTerminalState = async () => {
      setLoading(true);
      setError(null);

      try {
        const url = `/workspaces/${workspaceId}/terminal-state`;
        console.log('[useTerminalState] Fetching terminal state from:', url);
        
        const data = await api.get(url);
        console.log('[useTerminalState] Terminal state data:', data);
        setTerminalState(data);
      } catch (err) {
        console.error('[useTerminalState] Error fetching terminal state:', err);
        
        // Handle 404 specifically
        if (err.message && err.message.includes('404')) {
          console.log('[useTerminalState] 404 - No terminal state found');
          setTerminalState({ terminals: [] });
        } else {
          setError(err.message);
          setTerminalState({ terminals: [] });
        }
      } finally {
        setLoading(false);
      }
    };

    fetchTerminalState();
  }, [workspaceId, api]);

  return { terminalState, loading, error };
};

export default useTerminalState; 